module.exports = __webpack_public_path__ + "static/mcf-logo-77429484bdf3bdb774402215fbb8fac6.png";